/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BabylonFaucetClaimInfo } from '../models/BabylonFaucetClaimInfo';
import type { BabylonFaucetClaimRequest } from '../models/BabylonFaucetClaimRequest';
import type { BabylonFaucetClaimStatusInfo } from '../models/BabylonFaucetClaimStatusInfo';
import type { BabylonFaucetClaimStatusRequest } from '../models/BabylonFaucetClaimStatusRequest';
import type { BabylonFaucetStatusInfo } from '../models/BabylonFaucetStatusInfo';
import type { CommonEmptyRequest } from '../models/CommonEmptyRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class FaucetControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getFaucetStatus({
        requestBody,
    }: {
        requestBody?: CommonEmptyRequest,
    }): CancelablePromise<BabylonFaucetStatusInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/faucet/status',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public claimToken({
        xForwardedFor,
        requestBody,
    }: {
        xForwardedFor: string,
        requestBody: BabylonFaucetClaimRequest,
    }): CancelablePromise<BabylonFaucetClaimInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/faucet/claim',
            headers: {
                'X-Forwarded-For': xForwardedFor,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getFaucetClaimStatus({
        requestBody,
    }: {
        requestBody: BabylonFaucetClaimStatusRequest,
    }): CancelablePromise<BabylonFaucetClaimStatusInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/faucet/claim/status',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
